/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceBusStatistic } from '../../models/service-bus-statistic';

export interface MonitorServiceBusGet$Params {
}

export function monitorServiceBusGet(http: HttpClient, rootUrl: string, params?: MonitorServiceBusGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<ServiceBusStatistic>> {
  const rb = new RequestBuilder(rootUrl, monitorServiceBusGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<ServiceBusStatistic>;
    })
  );
}

monitorServiceBusGet.PATH = '/Monitor/ServiceBus';
